<mvs-widget
        [widgetData]="widgetTicketTableMe"
        [importObjectContext]="importObjectContextDto"
        (onObjectSelect)="onTicketSelect($event)"
></mvs-widget>